export enum IntegrationType {
  ConversationalAnalytics = 0,
  VirtualAgent = 1,
}
